import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    any: translate({ id: 'global.any' }),
    timeWindows: translate({ id: 'global.timeWindows' }),
  }))

  return api
}
